import styled, { css } from 'styled-components';
import {
  smallBreakpoint,
  mediumBreakpoint,
  xxlBreakpoint,
} from 'utilities/constants';

export const Container = styled.div`
  position: relative;
  height: 600px;
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  margin-top: -230px;

  @media (min-width: ${smallBreakpoint}px) {
    background: #f7fafc;
    margin-top: -100px;
  }
`;

export const Inner = styled.div`
  position: relative;
`;

export const BackgroundContainer = styled.div`
  position: absolute;
  bottom: -200px;
  left: 0;
  height: 100%;
  width: 100%;
  animation: compensateScrollIn 1s forwards;

  @keyframes compensateScrollIn {
    to {
      bottom: 0;
    }
  }

  svg {
    transform: scaleY(-1) scale(1);
    margin: 0;
    height: 100%;
  }
`;

export const PulsingImageArea = styled.div`
  display: grid;
  position: relative;
  float: left;
  margin-top: 250px;
  height: 100%;
  width: 100%;
  bottom: 0;

  @media (min-width: ${smallBreakpoint}px) {
    width: 45%;
  }
`;

const PulseAnimation = ({ delay }: { delay: number }) => {
  return css`
    opacity: 0;
    animation: pulseImgs ease infinite alternate;
    animation-duration: 3s;
    animation-delay: ${delay}s;

    @keyframes pulseImgs {
      to {
        opacity: 0.9;
      }
    }
  `;
};

export const PulsingImage = styled.img`
  position: absolute;
  border-radius: 100px;
  border: solid #f7fafc 3px;

  width: 15vw;
  height: 15vw;
  max-width: 160px;
  max-height: 160px;
  min-width: 75px;
  min-height: 75px;

  @media (min-width: ${smallBreakpoint}px) {
    min-width: 110px;
    min-height: 110px;
  }

  :nth-child(1) {
    margin-top: 70px;
    margin-left: 20px;

    ${PulseAnimation({ delay: 0 })}
  }

  :nth-child(2) {
    margin-top: 80px;
    margin-left: 33%;

    ${PulseAnimation({ delay: 2 })}

    @media (min-width: ${smallBreakpoint}px) {
      margin-top: 180px;
      margin-left: 30%;
    }
  }

  :nth-child(3) {
    margin-top: 0px;
    margin-left: 47%;

    ${PulseAnimation({ delay: 3 })}

    @media (min-width: ${smallBreakpoint}px) {
      margin-top: 0px;
      margin-left: 50%;
    }
  }

  :nth-child(4) {
    margin-top: 10px;
    margin-left: 75%;

    ${PulseAnimation({ delay: 5 })}

    @media (min-width: ${smallBreakpoint}px) {
      margin-top: 190px;
      margin-left: 70%;
    }
  }

  :nth-child(5) {
    margin-top: -80px;
    margin-left: 70%;

    ${PulseAnimation({ delay: 6.5 })}

    @media (min-width: ${smallBreakpoint}px) {
      margin-top: 10px;
      margin-left: 85%;
    }
  }

  :nth-child(6) {
    margin-top: 90px;
    margin-left: 60%;

    ${PulseAnimation({ delay: 7.5 })}

    @media (min-width: ${smallBreakpoint}px) {
      margin-top: -150px;
      margin-left: 110%;
    }
  }
`;

export const Content = styled.div`
  float: right;
  width: 100%;
  max-width: 500px;
  margin-top: 170px;
  padding: 0 10px;
  text-align: center;
  color: white;

  @media (min-width: ${smallBreakpoint}px) {
    width: 50%;
    margin-top: 330px;
  }

  @media (min-width: ${mediumBreakpoint}px) {
    width: 45%;
    margin-right: 5vw;
    padding: 20px;
  }

  @media (min-width: ${xxlBreakpoint}px) {
    margin-right: 12vw;
    padding: 20px;
  }

  h2 {
    margin-bottom: 20px;
    font-size: 1.5rem;

    @media (min-width: ${smallBreakpoint}px) {
      margin-bottom: 50px;
      font-size: 2rem;
    }
  }

  p {
    margin-top: 10px;
    margin-bottom: 0;

    @media (min-width: ${mediumBreakpoint}px) {
      margin-top: 25px;
    }
  }

  .button-container {
    margin-bottom: 10px;
    display: inline-flex;

    button {
      display: inline-flex;
      margin-left: 15px;
      margin-right: 15px;
      color: #265689;
      background-color: #f7fafc;
      text-transform: uppercase;
      font-size: 12px;
      font-weight: 600;
      width: 140px;
      height: 40px;
      align-items: center;
      white-space: nowrap;
      box-shadow: #293e54 0px 0px 8px 1px;

      @media (max-width: ${mediumBreakpoint}px) {
        margin: auto 5px;
      }
    }

    svg {
      margin-right: 10px;
      width: 25px;
      height: 100%;
      vertical-align: top;
    }
  }
`;
